import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Store } from "fond/types";

interface AccountContextState {
  currentAccountId: string | null;
  isInitialized: boolean;
  isSwitchingAccount: boolean;
}

const initialState: AccountContextState = {
  currentAccountId: null,
  isInitialized: false,
  isSwitchingAccount: false,
};

/**
 * Redux slice to store the current account context.
 * This is the source of truth for which account the user is currently viewing.
 * localStorage is kept in sync for cross-tab communication.
 */
export const accountContextSlice = createSlice({
  name: "accountContext",
  initialState,
  reducers: {
    setCurrentAccountId: (state, action: PayloadAction<string | null>) => {
      state.currentAccountId = action.payload;
      state.isInitialized = true;
    },
    startAccountSwitch: (state) => {
      state.isSwitchingAccount = true;
    },
  },
});

export const { setCurrentAccountId, startAccountSwitch } = accountContextSlice.actions;

export const selectCurrentAccountId = (state: Store): string | null => state.accountContext?.currentAccountId || null;

export const selectIsAccountContextInitialized = (state: Store): boolean => state.accountContext?.isInitialized ?? false;

export const selectIsSwitchingAccount = (state: Store): boolean => state.accountContext?.isSwitchingAccount ?? false;
